export default "__VITE_ASSET__CD5FK$qR__"